/* eslint-disable global-require */
module.exports = [...require('./Subjects/i18n'), ...require('./MessageSent/i18n'), 'auctioneers.contact.m1', 'auctioneers.contact.m2', 'auctioneers.contact.m3', 'auctioneers.contact.m4', 'auctioneers.contact.m5'];
